export default "__VITE_ASSET__BA87CFOh__"